import React from "react";
import PropTypes from "prop-types";

import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import TListItem from "../../../Library/OtherComponents/TListItem";

import { shouldComponentUpdateGB } from "../../GB/NonComponents/GBUtil";

import * as SCConst from "../NonComponents/SCConst";
import {
    getCountryNames,
    getCountryMstIDs,
    getCountryOLIndex,
    getStartingCountryCode,
    getUserCountryObjList,
} from "../NonComponents/SCDataUtil";

import TComboBox from "../../../Library/ComboBoxes/TComboBox";

class SCAppSideBarCustom extends React.Component {
    //==================================================================================================================
    //
    //                                             Props and State
    //
    //==================================================================================================================

    static propTypes = {
        isGuest: PropTypes.bool,
        allowedCountryMstIDs: PropTypes.array,
        countryObjList: PropTypes.array,
        selectedCountryCode: PropTypes.number,
        pageID: PropTypes.string,
        onPageChange: PropTypes.func,
        onDrawerChange: PropTypes.func,
        onCountryChange: PropTypes.func,
    };

    static defaultProps = {
        isGuest: true,
        allowedCountryMstIDs: [],
        countryObjList: [],
        selectedCountryCode: 0,
        pageID: "",
        onPageChange: () => console.log("onPageChange"),
        onDrawerChange: () => console.log("onDrawerChange"),
        onCountryChange: () => console.log("onCountryChange"),
    };

    /* Avoid re-rendering if we don't have to (if no props or state affect this form). */
    shouldComponentUpdate(nextProps, nextState) {
        return shouldComponentUpdateGB(this.props, nextProps, this.state, nextState);
    }

    //==================================================================================================================
    //
    //                                                 Events
    //
    //==================================================================================================================

    onCountryComboboxChange = (value, text, info) => {
        try {
            this.props.onCountryChange(info);
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    //==================================================================================================================
    //
    //                                                 Render
    //
    //==================================================================================================================

    getStyle = (pageID) => {
        try {
            return this.props.pageID === pageID ? { fontWeight: "bold" } : {};
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
            return {};
        }
    };

    render() {
        try {
            const countryObjList = this.props.countryObjList;
            const isGuest = this.props.isGuest;
            const allowedCountryMstIDs = this.props.allowedCountryMstIDs;

            let selectedCountryCode = this.props.selectedCountryCode;
            const userCountryObjList = getUserCountryObjList(isGuest, countryObjList, allowedCountryMstIDs);

            if (selectedCountryCode === 0) {
                selectedCountryCode = getStartingCountryCode(userCountryObjList);
            }

            let countryComboBox = null;
            let divider = null;

            if (window.VIPT_Version === window.VIPT_Versions.Global) {
                const countryComboBoxStyle = {
                    width: 200,
                    marginLeft: 20,
                    marginTop: 10,
                    marginBottom: 10,
                };
                const countryNames = getCountryNames(userCountryObjList);
                const countryMstIDs = getCountryMstIDs(userCountryObjList);
                const countryOLIndex = getCountryOLIndex(userCountryObjList, selectedCountryCode);

                //let quarterInfo = [];
                // for (let i = 1; i <= 4; i++) {
                //     quarterInfo.push([SCConst.quarter, i]);
                // }

                if (countryNames !== null && countryMstIDs !== null && countryOLIndex !== null) {
                    countryComboBox = (
                        <TComboBox
                            caption="Select a country"
                            onChange={this.onCountryComboboxChange}
                            info={countryMstIDs}
                            itemIndex={countryOLIndex}
                            items={countryNames}
                            style={countryComboBoxStyle}
                        />
                    );
                }

                divider = <Divider />;
            }

            const welcomeListItem = (
                <TListItem
                    caption={"Welcome"}
                    primaryStyle={this.getStyle(SCConst.SCWelcomeFormPg)}
                    onClick={() => this.props.onPageChange(SCConst.SCWelcomeFormPg)}
                />
            );

            const locationsListItem = (
                <TListItem
                    caption={"Locations"}
                    onClick={() => this.props.onDrawerChange(SCConst.locationsDrawer)}
                />
            );

            const characteristicsListItem = (
                <TListItem
                    caption={"Characteristics"}
                    onClick={() => this.props.onDrawerChange(SCConst.characteristicsDrawer)}
                />
            );

            // {/*<TListItem*/}
            // {/*caption={"Time period"}*/}
            // {/*onClick={() => this.props.onDrawerChange(SCConst.timePeriodDrawer)}*/}
            // {/*/>*/}
            const resultsListItem = (
                <TListItem
                    caption={"Results"}
                    onClick={() => this.props.onDrawerChange(SCConst.resultsDrawer)}
                />
            );

            let dataEntryListItem = null;

            if (selectedCountryCode !== SCConst.countryCodeSampleCountry) {
                dataEntryListItem = (
                    <TListItem
                        caption={"Data entry"}
                        onClick={() => this.props.onDrawerChange(SCConst.editTemplateDrawer)}
                    />
                );
            }

            return (
                <div>
                    {countryComboBox}
                    {divider}

                    <List>
                        {welcomeListItem}
                        {locationsListItem}
                        {characteristicsListItem}
                        {resultsListItem}
                        {dataEntryListItem}
                    </List>

                    {/*<List>*/}
                    {/*<TListItem*/}
                    {/*caption={"Welcome"}*/}
                    {/*primaryStyle={this.getStyle('SCWelcome')}*/}
                    {/*onClick={() => this.props.onPageChange('SCWelcome')}*/}
                    {/*/>*/}
                    {/*<TListItem*/}
                    {/*caption={"Visualize"}*/}
                    {/*primaryStyle={this.getStyle(SCConst.SCResultsFormPg)}*/}
                    {/*onClick={() => this.props.onPageChange(SCConst.SCResultsFormPg)}*/}
                    {/*/>*/}
                    {/*<div>*/}
                    {/*<TListItem*/}
                    {/*caption={"Results"}*/}
                    {/*onClick={() => this.props.onDrawerChange(SCConst.resultsDrawer)}*/}
                    {/*/>*/}
                    {/*<TListItem*/}
                    {/*caption={"Locations"}*/}
                    {/*onClick={() => this.props.onDrawerChange(SCConst.locationsDrawer)}*/}
                    {/*/>*/}
                    {/*<TListItem*/}
                    {/*caption={"Characteristics"}*/}
                    {/*onClick={() => this.props.onDrawerChange(SCConst.characteristicsDrawer)}*/}
                    {/*/>*/}
                    {/*<TListItem*/}
                    {/*caption={"Time period"}*/}
                    {/*onClick={() => this.props.onDrawerChange(SCConst.timePeriodDrawer)}*/}
                    {/*/>*/}
                    {/*<TListItem */}
                    {/*caption={"Data entry"} */}
                    {/*onClick={() => this.props.onDrawerChange(SCConst.editTemplateDrawer)} */}
                    {/*/>*/}
                    {/*</div>*/}
                    {/*</List>*/}
                </div>
            );
        } catch (exception) {
            return (
                <div
                    className={"SCAppSideBarCustomDiv"}
                    key={"SCAppSideBarCustomDiv"}
                >
                    <h3 key={"SCAppSideBarCustomDivH3"}>{exception.name + ": " + exception.message}</h3>
                </div>
            );
        }
    }
}

export default SCAppSideBarCustom;
